import React, { FC } from 'react';
import { Button, Dialog, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import styles from './CancelAppointmentDialog.module.css';
import sharedStyles from '../../shared.module.css';

export const CancelAppointmentDialog: FC<{
    handleConfirmCancel: (input: boolean) => void;
    isOpen: boolean;
}> = ({ handleConfirmCancel, isOpen }) => {
    return (
        <Dialog
            className={styles.cancelApptDialog}
            open={isOpen}
            onClose={() => handleConfirmCancel(false)}
        >
            <img
                className={sharedStyles.graceImage}
                src={'/logo.svg'}
                alt="Grace Icon"
            />
            <DialogContent className={styles.cancelApptDialogContent}>
                <IconButton
                    aria-label="close"
                    className={styles.cancelApptDialogClose}
                    onClick={() => {
                        handleConfirmCancel(false);
                    }}
                >
                    <CloseIcon className={styles.cancelApptDialogCloseIcon} />
                </IconButton>
                <p className={styles.cancelApptDialogText}>
                    Please confirm that you would like to cancel this
                    appointment.
                </p>
                <Button
                    className={styles.cancelApptDialogConfirm}
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        handleConfirmCancel(true);
                    }}
                >
                    Confirm
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default CancelAppointmentDialog;
